import React from 'react'
import { Box, Field, SwitchRoot, SwitchThumb } from '@workwhile/ui'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { ModalSelect } from 'components/ModalSelect'
import {
  BREAKDOWN_LEVEL_OPTIONS,
  InvoiceConfigValuesSchema,
  TIMEZONE_OPTIONS,
  WEEK_START_DAY_OPTIONS,
} from '../schemas/invoiceConfigValues'

type OptionType = { label: string; value: string }

export const InvoiceConfigValuesFields = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<InvoiceConfigValuesSchema>()

  const useCustomWeek = useWatch({ control, name: 'useCustomWeek' })

  return (
    <>
      <Box mt={4}>
        <Field
          label="Breakdown Levels"
          error={errors.breakdownLevels?.message?.toString()}
        >
          <Controller
            name="breakdownLevels"
            control={control}
            render={({ field }) => (
              <ModalSelect<OptionType, true>
                isMulti
                options={BREAKDOWN_LEVEL_OPTIONS}
                value={BREAKDOWN_LEVEL_OPTIONS.filter((option) =>
                  (field.value ?? []).includes(option.value)
                )}
                onChange={(selected) =>
                  field.onChange(selected.map((option) => option.value))
                }
                placeholder="Select breakdown levels..."
              />
            )}
          />
        </Field>
      </Box>
      <Box mt={4}>
        <Field label="Use custom week">
          <Controller
            name="useCustomWeek"
            control={control}
            render={({ field }) => (
              <SwitchRoot
                checked={field.value}
                onCheckedChange={(value) => field.onChange(value)}
                aria-label="Use custom week"
              >
                <SwitchThumb>{field.value ? 'Yes' : 'No'}</SwitchThumb>
              </SwitchRoot>
            )}
          />
        </Field>
      </Box>
      {useCustomWeek ? (
        <>
          <Box mt={4}>
            <Field
              label="Week Start Day"
              error={errors.weekStartDay?.message?.toString()}
            >
              <Controller
                name="weekStartDay"
                control={control}
                render={({ field }) => (
                  <ModalSelect
                    options={WEEK_START_DAY_OPTIONS}
                    value={WEEK_START_DAY_OPTIONS.find(
                      (option) => option.value === field.value
                    )}
                    onChange={(option: OptionType | null) =>
                      field.onChange(option?.value)
                    }
                    placeholder="Select week start day..."
                  />
                )}
              />
            </Field>
          </Box>
          <Box mt={4}>
            <Field
              label="Timezone"
              error={errors.timezone?.message?.toString()}
            >
              <Controller
                name="timezone"
                control={control}
                render={({ field }) => (
                  <ModalSelect
                    options={TIMEZONE_OPTIONS}
                    value={TIMEZONE_OPTIONS.find(
                      (option) => option.value === field.value
                    )}
                    onChange={(option: OptionType | null) =>
                      field.onChange(option?.value)
                    }
                    placeholder="Search timezones..."
                    filterOption={(option, input) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                )}
              />
            </Field>
          </Box>
        </>
      ) : null}
    </>
  )
}
